import { CONSTRAINT_LIMITS, MESSAGES } from 'shared/config/validations';
import * as Yup from 'yup';

export const TagInputSchema = Yup.array(Yup.string().max(CONSTRAINT_LIMITS.TAG_MAX_LENGTH, MESSAGES.TAG_LENGTH));

// Pure Function
export function parseTags(tags: string): string[] {
  return tags ? JSON.parse(tags).map((tag) => tag.value) : [];
}
